import * as React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';
import { handleFormImageUpload } from '../../utils';

const EditPromo = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = React.useState([]);
	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/promo/${id}`)
		.then(({ data = {} }) => {
			const { result = {} } = data;
			const responseFields = (result?.data ?? []).map((field) => {
				if (field.key === 'title') {
					return {
						...field,
						customProps: {
							extra: '92 тэмдэгтээс хэтэрсэн тохиолдолд аппликейшнд "..." тэмдэгээр хязгаарлагдахыг анхаарна уу!'
						}
					}
				}
				if (['publishedDate'].includes(field.key)) {
					return {
						...field,
						// disabledDate: disableDateBeforeToday,
					}
				}
				if (field.key === "image") {
					return {
						...field,
						value: [{
							url: field?.value || null,
						}]
					};
				}

				return {
					...field,
				};
			});

			setFields(responseFields);
		})
		.catch(err => {
			console.log(err);
		})
	}, [id]);

	const handleSubmit = (fields) => {
		axios.post(`/api/promo/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/promo');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/promo')
	};

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Промо засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
				imageUpload={handleFormImageUpload}
			/>
		</PageContent>
	)
}

export default EditPromo;